import React from "react";
import { Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
  stepLabel: {
    marginRight: theme.spacing(2)
  },
  stepInstruction: {
    marginBottom: theme.spacing(2),
    lineHeight: 1.75
  },
  stepWrapper: {
    display: "flex",
    marginBottom: theme.spacing(2)
  },
  stepContent: {
    display: "flex",
    flex: 1,
    flexDirection: "column"
  }
}));

type Props = {
  instruction: string;
  index: number;
  children: JSX.Element;
};

const Step: React.FC<Props> = ({ instruction, index, children }) => {
  const classes = useStyles();

  return (
    <div className={classes.stepWrapper}>
      <Typography
        className={classes.stepLabel}
        color="primary"
        variant="subtitle1"
      >{`Step ${index}`}</Typography>
      <div className={classes.stepContent}>
        <Typography className={classes.stepInstruction} color="textSecondary">
          {instruction}
        </Typography>
        {children}
      </div>
    </div>
  );
};

export default Step;
